<mat-card class="panel_search mat-card flex-center">
  <!--sub header-->
  <div class="panel_sub_header">
      <span class="panel__header__title">Add Component Images</span>
  </div>
  <h1 style="display:none" mat-dialog-title>Hi {{data.compartid_auto}}</h1>
  <img style="width:100px; height:100px" *ngIf="attachment_comp" [src]="sanitize(attachment_comp)">

  <div class="upload-container"  title="{{'Add photo' | translate | async}}">
      <i class="material-icons upload-container__icon">
          add_a_photo
      </i>
         <input type="file" accept="image/*" (change)="onSelectPhoto($event)" > 
   </div>

  <div mat-dialog-actions>
      <button mat-button class="button button--primary" (click)="NoClick()">Cancel <i class="material-icons button__icon"></i><span
              class="button__text"></span></button>
      <button mat-button class="button button--primary" (click)=" saveCompImageDialog()" cdkFocusInitial>Save <i class="material-icons button__icon"></i><span
              class="button__text"></span></button>
  </div>
</mat-card>